var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{class:_vm.className,attrs:{"items":_vm.pickerYear,"label":_vm.label,"outlined":"","dense":"","clearable":true},on:{"change":function($event){return _vm.handleChange()}},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}})
}
var staticRenderFns = []

export { render, staticRenderFns }